import { ArrowDownSec } from '@/components/icons/ArrowDownSec'
import { Headline2 } from '@/components/common/Headline2'
import { useRef, useState } from 'react'
import { useBetterMediaQuery } from '@/hooks/BetterMediaQuery'

interface PanelsArrayProps {
  title?: string
  iconPosition?: 'left' | 'top'
  items: {
    icon?: React.ReactNode
    title?: string
    description?: string
    component?: React.ReactNode,
    width?: string
  }[],
  height?: string
  className?: string
  centered?: boolean
  style?: 'light' | 'dark'
}

export const PanelsArray: React.FC<PanelsArrayProps> = ({ title, items, className, iconPosition = 'top', height = 'xl:h-[200px]', style = 'dark', centered = false }) => {
  const [index, setIndex] = useState(0)
  const touchStartX = useRef<number | null>(null)
  const touchEndX = useRef<number | null>(null)
  const sm = useBetterMediaQuery('(max-width: 768px)')

  const next = () => setIndex((index + 1) % items.length)
  const prev = () => setIndex((index - 1 + items.length) % items.length)
  const goTo = (i: number) => setIndex(i)

  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX
  }

  const handleTouchMove = (e: React.TouchEvent) => {
    touchEndX.current = e.touches[0].clientX
  }

  const handleTouchEnd = () => {
    const distance = (touchStartX.current || 0) - (touchEndX.current || 0)
    if (distance > 50) next()
    else if (distance < -50) prev()
  }

  return (
    <div className={`${className}`}>
      { title &&
        <div className='flex mb-[24px] justify-between'>
          <Headline2 tag="h3" weight={600} color={style === 'dark' ? 'black' : 'white'} className="text-[18px] xl:text-[24px] !leading-[1] z-10 relative">{title}</Headline2>
          <ArrowDownSec color={style === 'dark' ? 'black' : 'white'}/>
        </div>
      }
      {
        <div
          className={`flex flex-col xl:flex-row xl:flex-wrap xl:ml-[-8px] xl:mr-[-8px] ${centered ? 'justify-center' : ''}`}
        >
          {items.map((item, index) => (
            <div key={index} className={`${item.width ? item.width : 'xl:w-[33.3333%]'} flex mb-[16px] xl:mb-0`}>
              { item.component ?
                item.component :
                (
                  <div className={`bg-white px-[24px] py-[36px] xl:m-[8px] rounded-[16px] shadow-xl shadow-black/5 w-full ${height} flex`}>
                    {iconPosition === 'top' ? (
                      <div className='flex flex-col justify-center'>
                        {item.icon}
                        <Headline2 tag="h4" weight={600} color='black' className="text-[18px] !leading-[1.2] z-10 relative mt-[16px] mb-[10px]">{item.title}</Headline2>
                        <p className='font--accent text-black opacity-[0.5]'>{item.description}</p>
                      </div>
                    ) : (
                      <div className='flex items-center gap-[16px]'>
                        {item.icon}
                        <div>
                          <Headline2 tag="h4" weight={600} color='black' className="text-[18px] !leading-[1.2] z-10 relative mb-[10px]">{item.title}</Headline2>
                          <p className='font--accent text-black opacity-[0.5]'>{item.description}</p>
                        </div>
                      </div>
                    )}
                  </div>
                )
              }
            </div>
          ))}
        </div>
      }
    </div>
  )
}
